import { events } from "@/mocks/events";
import { categories } from "@/mocks/site";

export type SiteEvent = (typeof events)[number];
export type SiteCategory = (typeof categories)[number];

export function getEventBySlug(slug: string): SiteEvent | undefined {
  return events.find((event) => event.slug === slug);
}

export function getCategoryBySlug(slug: string): SiteCategory | undefined {
  return categories.find((category) => category.slug === slug);
}

export function getCategoryName(slug: string): string {
  return getCategoryBySlug(slug)?.name ?? "事件复盘";
}

export function getFeaturedEvents(): SiteEvent[] {
  const featured = events.filter((event) => event.featured);
  return featured.length > 0 ? featured : events.slice(0, 1);
}

export function getLatestEvents(limit?: number): SiteEvent[] {
  const sorted = [...events].sort(
    (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime(),
  );
  return typeof limit === "number" ? sorted.slice(0, limit) : sorted;
}

export function getEventsByCategory(slug: string): SiteEvent[] {
  return events.filter((event) => event.categorySlug === slug);
}

export function getRelatedEvents(event: SiteEvent, limit = 3): SiteEvent[] {
  const related = event.relatedSlugs
    .map((slug) => getEventBySlug(slug))
    .filter((item): item is SiteEvent => Boolean(item));
  if (related.length >= limit) {
    return related.slice(0, limit);
  }
  const filler = events.filter(
    (item) => item.slug !== event.slug && !related.some((r) => r.slug === item.slug),
  );
  return [...related, ...filler].slice(0, limit);
}

export function formatDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return iso;
  }
  return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
}

export function summarizeStatus(status: string): string {
  return status;
}